var React = require('react');

function PillLong (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M27.75 52.9551C13.4729 52.9551 1.8916 41.3288 1.8916 26.9776C1.8916 12.6263 13.4729 1 27.75 1H182.502C196.779 1 208.36 12.6264 208.36 26.9776C208.36 41.3288 196.779 52.9551 182.502 52.9551H27.75Z","strokeWidth":"2"}));
}

PillLong.defaultProps = {"width":"210","height":"54","viewBox":"0 0 210 54"};

module.exports = PillLong;

PillLong.default = PillLong;
